import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Observable, of } from 'rxjs';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatChip } from '@angular/material';
import { DocumentoService } from '../../services/documento.service';
import { Element } from '@angular/compiler';
import { DocumentosModel } from './busca-documentos.model';
import { AlertService } from '../../providers/alert.service'
import { ExcluirDocumentoComponent } from '../excluir-documento/excluir-documento.component'
import { SessionService } from '../../providers/session.service'
import {PageEvent} from '@angular/material/paginator';

import { Validators, FormBuilder, FormGroup } from "@angular/forms"
@Component({
	selector: 'app-busca-documentos',
	templateUrl: './busca-documentos.component.html',
	styleUrls: ['./busca-documentos.component.scss', '../../assets/less/all.less']
})
export class BuscaDocumentosComponent implements OnInit {
	loading = false;
	tipos;
	nativeWindow: any;
	adm = false;
	indexador = 'Indexador';

	// MatPaginator Output
	pageEvent: PageEvent;
	
    public busca_form: FormGroup
	documento = {
		tipo: null,
		indexador: null,
		_id: null, 
		cod_documento: null, 
		num_documento: null, 
		ano_doc: null, 
		titulo: null, 
		// caminho_arquivo: null,
		tags: null, 
		data_doc: null, 
		classificacao: null,
		observacoes: null, 
		tipo_origem: null, 
		cliente: null, 
		empresa: null, 
		status: null, 
		descricao: null,
		extencao_doc: null, 
		file_type: null, 
		tamanho_doc: null, 
		file: null, 
		fileSeq: null, 
		tipo_doc: null, 
	}

	id = -1;
	displayedColumns = ['tipo_doc', 'titulo', 'acoes'];
	dataSource: DocumentoDataSource | null;
	isTableAvailable = false;

	length: number;
	pageIndex: number = 1;
	pageSize: number = 20;
	pageSizeOptions: number[] = [5, 10, 25, 50, 100];
	data: any;


	constructor(
		public router: Router,
        public documento_service: DocumentoService,
        public dialog: MatDialog,
		public alerts: AlertService,
		private session_provider: SessionService,
        public formBuilder: FormBuilder, 
		
	) {
		this.nativeWindow = documento_service.getNativeWindow();
		this.busca_form = this.formBuilder.group({
			tipo: ['',Validators.required] ,
			indexador: ['',Validators.nullValidator],
			// status: ['',Validators.required],
			// telefone: ['', Validators.nullValidator],
			// cep: ['',Validators.required],
			// logradouro: ['',Validators.required],
			// numero: ['',Validators.required],
			// complemento: ['',Validators.required],
			// bairro: ['',Validators.required],
			// cidade: ['',Validators.required],
			// uf: ['',Validators.required],
			// email: ['', Validators.nullValidator],
			// site: ['', Validators.nullValidator],
			// nome_contato: ['', Validators.nullValidator]
		})
	}

	ngOnInit() {
		this.getTipos()
		this.getAdministrador()
		this.getClienteSessao()
	}

	getAdministrador(){
		
		// this.session_provider.getAdm()
		this.adm = this.session_provider.getAdm()
	}
	
	getClienteSessao(){
		let cliente = this.session_provider.getClienteUsuario()
		console.log('Cliente', cliente)
		this.indexador
		if(cliente == 'APVS Brasil'){
			this.indexador = 'Nome / Placa do Veículo'
		}
		if(cliente == 'WLT' || cliente == 'WLT SINDICO'){
			this.indexador = 'Condomínio / Competência'
		}
	}

	getTipos(){
		this.documento_service.getListaTipos()
            .then(data => {
                if (data) {
                    this.tipos = data;
                    this.loading = false;
                } else {
                    this.alerts.openAlert("Ops,", 'Ocorreu um erro, tente novamente mais tarde')
                }
            })
            .catch(error => {
                this.loading = false;
            });
	}

	buscar() {
        this.loading = true;
        documento = null;
        this.isTableAvailable = false;
        this.loadData(this.pageIndex);
	}
	
	loadData(page) {
        this.documento_service.getImagem(this.documento['tipo'], this.documento['indexador'], page)
		.then(data => {
			if (data['items']) {
				documento = data['items'];
				console.log(data);
				this.setPagination(data['_meta']['count'], data['_meta']['page'], data['_meta']['pageSize']);
				this.dataSource = new DocumentoDataSource(documento);
				console.log("datasource", this.dataSource)
				this.isTableAvailable = true;
				this.loading = false;
			} else {
				this.loading = false;
				this.alerts.openAlert("Ops,", 'Ocorreu um erro, tente novamente mais tarde')
			}
		})
		.catch(error => {
			this.loading = false;
		});
	}

	download(id){
		this.loading = true
		console.log('download')
		this.documento_service.getPDF(id)
		.subscribe(x => {
			var newBlob = new Blob([x], { type: "application/pdf" });
			console.log('then')
			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob);
                return;
			}
			
			const data = window.URL.createObjectURL(newBlob);

            var link = document.createElement('a');
            link.href = data;
            link.download = "GSViewer Download.pdf";
            // this is necessary as link.click() does not work on the latest firefox
            link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
                link.remove();
            }, 100);
			this.loading = false
		},
		error => {
			this.loading = false
			this.alerts.openAlert("Ops,", 'Ocorreu um erro, tente novamente mais tarde')
		}
		)
		
	}
	
	setPagination(length, startIndex, pageSize) {
        this.length = length;
        this.pageIndex = startIndex;
        this.pageSize = pageSize;
    }

    onPaginateChange(event) {
        console.log("evento")
        console.log(event);
        this.pageIndex = event.pageIndex + 1;
        this.pageSize = event.pageSize;
        console.log(this.pageSize)
        this.loading = true;
        this.loadData(this.pageIndex);
	}

	
    abreDocumento(id) {
        this.router.navigate(['pdf-view', id])
	}
	
    alterar(id) {
        this.router.navigate(['cadastro-cliente', id])
    }

    excluirDocumento(documento) {
        let dialogRef = this.dialog.open(ExcluirDocumentoComponent, {
            width: '700px',
            data: documento
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                documento = null;
                this.loadData(this.pageIndex);
            }
        });
    }

}

let documento;

export interface Element {
    ano_doc: null 
	// caminho_arquivo: null 
	classificacao: null 
	cod_documento: null 
	created_at: null 
	created_by: null 
	data_doc: null 
	extencao_doc: null 
	file_type: null 
	num_documento: null
	status: null 
	tags: null 
	tamanho_doc: null 
	tipo_doc: null 
	titulo: null 
	updated_at: null 
	updated_by: null
	_id: null 
}

export class DocumentoDataSource extends DataSource<any> {
	connect(): Observable<DocumentosModel[]> {
		console.log(documento);
		return of(this._documento);
	}

	constructor(private _documento: DocumentosModel[]) {
		super();
	}

	disconnect() { }
}

